<template>
    <div class="warehouse-main-page">
        <base-header
            class="warehouse-main-page__header"
            :titulo="translate('messages.main_title')"
            icon="el-icon-document-add"
            :exibe-botao="true"
            :btn-texto="translate('messages.individual_record')"
            iconBotaoSecundario="el-icon-upload"
            :exibeBotaoSecundarioAcao="true"
            :btnTextoAcoes="translate('messages.batch_upload')"
            :acoes="actions"
            @realizarAcao="chooseAction($event)"
            @btnHeaderClicado="add()"
            :iconesAcoes="true"
            :exibeBotaoTerciario="true"
            iconBotaoTerceario="el-icon-check"
            :btnTextoTerciario="translate('messages.inbound_invoices')"
            @btnHeaderClicadoTerciario="irNotasEntrada()"
        />
        <div class="view-container-wrapper">
            <div class="content">
                <div class="sumary-filter">
                    <pending-invoices-card v-if="this.pendingNotes" :pendingNotes="pendingNotes"/>
                </div>
                <el-tabs
                    v-model="activeName"
                    class="warehousemain-page-tabs"
                    @tab-click="changeTab"
                >
                    <el-tab-pane :label="translate('messages.warehouses')" :name="tabNames.warehousesTab">
                        <search-filters @changeFilters="changeFilters" />
                        <el-form label-position="top">
                            <totalizers ref="totalizers" :filters="filters" />
                            <warehouse-list ref="warehouseList" :filters="filters" />
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane :label="translate('messages.industries')" :name="tabNames.factoriesTab">
                        <search-filters @changeFilters="changeFilters" />
                        <totalizers-factories ref="totalizers-factories" :filters="filters" />
                        <factory-list ref="factoryList" :filters="filters" />
                    </el-tab-pane>
                    <el-tab-pane :label="translate('messages.ports')" :name="tabNames.portsTab">
                        <search-filters @changeFilters="changeFilters" />
                        <totalizers-ports class="totalizers-ports-component" ref="totalizers-ports" :filters="filters" />
                        <port-list ref="portList" :filters="filters" />
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <add-invoice-modal
            :show="showAddInvoiceModal"
            @close="showAddInvoiceModal = false"
            @refreshStockPage="refreshStockPage"
        />
    </div>
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import SearchFilters from '@/modules/warehouse/views/pages/main/components/filters/index.vue';
import Totalizers from '@/modules/warehouse/views/pages/main/components/totalizers/index.vue';
import TotalizersFactories from '@/modules/warehouse/views/pages/main/components/totalizers-factories/index.vue';
import TotalizersPorts from '@/modules/warehouse/views/components/totalizers-ports/index.vue';
import WarehouseList from '@/modules/warehouse/views/pages/main/components/warehouse-list/index.vue';
import FactoryList from '@/modules/warehouse/views/pages/main/components/factory-list/index.vue';
import AddInvoiceModal from '@/modules/warehouse/views/pages/main/components/add-invoice-modal/index.vue';
import PendingInvoicesCard from '@/modules/warehouse/views/pages/main/components/pending-invoices-card/index.vue';
import RastreabilidadeTransacaoArmazemService from '@/services/RastreabilidadeTransacaoArmazemService';

import { mapState } from 'vuex';
import { BatchUploadActions } from '@/modules/warehouse/constants/BatchUploadActionsEnum';
import { MainPageTabs } from '@/modules/warehouse/constants/MainPageTabsEnum';
import PortList from '@/modules/warehouse/views/pages/main/components/port-list/index.vue';

export default {
    name: 'StockMainPage',
    components: {
        BaseHeader,
        Totalizers,
        WarehouseList,
        SearchFilters,
        AddInvoiceModal,
        PendingInvoicesCard,
        TotalizersFactories,
        FactoryList,
        TotalizersPorts,
        PortList
    },
    mounted() {
        this.fetchPendingNotes();
        if (this.selectedTab) {
            this.activeName = this.selectedTab;
        } else {
            this.$store.commit('warehouseModule/SET_MAIN_SELECTED_TAB', this.activeName);
        }
    },
    computed: {
        ...mapState(['usuarioLogado']),
        ...mapState('warehouseModule', ['selectedTab'])
    },
    data() {
        return {
            filters: {},
            showAddInvoiceModal: false,
            pendingNotes: 0,
            actions: [
                {
                    titulo: this.$t('warehouse.messages.grain_reception_from_producers'),
                    codigo: 'GRAIN_RECEPTION',
                    emit: BatchUploadActions.GRAIN_RECEPTION,
                    icon: 'lyra-icon-dropdown-menu lyra-enviar_notas'
                },
                {
                    titulo: this.$t('warehouse.messages.internal_transfer'),
                    codigo: 'INTERNAL_TRANSFER',
                    emit: BatchUploadActions.INTERNAL_TRANSFER,
                    icon: 'lyra-icon-dropdown-menu lyra-enviar_notas'
                },
                {
                    titulo: this.$t('warehouse.messages.external_transfer'),
                    codigo: 'EXTERNAL_TRANSFER',
                    emit: BatchUploadActions.EXTERNAL_TRANSFER,
                    icon: 'lyra-icon-dropdown-menu lyra-enviar_notas'
                },
                {
                    titulo: this.$t('warehouse.messages.loan_transfer_between_partners'),
                    codigo: 'LOAN_TRANSFER',
                    emit: BatchUploadActions.LOAN_TRANSFER,
                    icon: 'lyra-icon-dropdown-menu lyra-enviar_notas'
                }
            ],
            tabNames: {
                warehousesTab: MainPageTabs.WAREHOUSES_TAB,
                factoriesTab: MainPageTabs.FACTORIES_TAB,
                portsTab: MainPageTabs.PORTS_TAB
            },
            restrictedApprovalRoles: ['ROLE_FEATURE_CONTRATO_RASTREABILIDADE_APROVADOR'],
            activeName: 'warehouses-tab'
        };
    },
    watch: {
        '$i18n.locale': function (newLocale) {
            this.actions.forEach(action => {
                action.titulo = this.reloadActionLabel(action.codigo);
            });
        }
    },
    methods: {
        translate(key, params = {}) {
            const base = 'warehouse';
            return this.$t(`${base}.${key}`, params);
        },
        add() {
            this.showAddInvoiceModal = true;
        },
        changeFilters(filters) {
            this.filters = filters;
        },
        refreshStockPage() {
            const current = this.activeName;
            if (current === this.tabNames.warehousesTab) {
                this.$refs.warehouseList && this.$refs.warehouseList.getWarehouses && this.$refs.warehouseList.getWarehouses();
                this.$refs.totalizers && this.$refs.totalizers.getTotalizers && this.$refs.totalizers.getTotalizers();
            } else if (current === this.tabNames.factoriesTab) {
                this.$refs.factoryList && this.$refs.factoryList.getFactories && this.$refs.factoryList.getFactories();
                this.$refs['totalizers-factories'] && this.$refs['totalizers-factories'].getTotalizers && this.$refs['totalizers-factories'].getTotalizers();
            } else if (current === this.tabNames.portsTab) {
                this.$refs.portList && this.$refs.portList.getPorts && this.$refs.portList.getPorts();
                this.$refs['totalizers-ports'] && this.$refs['totalizers-ports'].getTotalizers && this.$refs['totalizers-ports'].getTotalizers();
            }
        },
        chooseAction(action) {
            this.$router.push({
                name: 'UploadNotasLote',
                params: { action: action }
            });
        },
        reloadActionLabel(actionCode) {
            if (actionCode === 'GRAIN_RECEPTION') {
                return this.translate('messages.grain_reception_from_producers');
            }
            if (actionCode === 'INTERNAL_TRANSFER') {
                return this.translate('messages.internal_transfer');
            }
            if (actionCode === 'EXTERNAL_TRANSFER') {
                return this.translate('messages.external_transfer');
            }
            if (actionCode === 'LOAN_TRANSFER') {
                return this.translate('messages.loan_transfer_between_partners');
            }
        },
        changeTab(tabName) {
            this.$store.commit('warehouseModule/SET_MAIN_SELECTED_TAB', tabName.paneName);
        },
        irNotasEntrada() {
            this.$router.push({ name: 'NotasEntrada' });
        },
        async fetchPendingNotes() {
            if (!this.usuarioLogado.armazemRastreabilidadeAccess) {
                this.pendingNotes = 0;
                return;
            }
            await RastreabilidadeTransacaoArmazemService.getCountPendentOperations()
                .then(response => {
                    this.pendingNotes = response.data;
                })
                .catch(() => {
                    this.pendingNotes = 0;
                });
        }
    }
};
</script>

<style scoped lang="scss">
.warehouse-main-page {
    .view-container-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px;
    }

    .warehouse-main-page__tabs {
        margin-top: 8px;
    }
}
.sumary-filter {
    display: flex;
    flex-direction: column;
}
.totalizers-ports-component {
    margin-top: 16px;
}
::v-deep .el-tabs__nav-wrap::after {
    display: none !important;
    border-bottom: none !important;
    padding: 0 8px 0 8px;
}
::v-deep .el-tabs__nav-wrap {
    padding: 0 8px 0 8px;
}
::v-deep .warehousemain-page-tabs .el-tab-pane > .main-filters {
    margin-bottom: 16px;
}

::v-deep .el-tabs__content {
    margin-top: 0;
    padding-top: 8px;
}
</style>
